import { Component, Input, OnInit, DestroyRef, inject } from '@angular/core';
import { AlertService } from '../../services/alert.service';
import { NgIf, NgClass, NgFor } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

const TIME_TO_LEAVE = '7000';

export enum ToastPosition {
  TOP_LEFT = 0,
  TOP_CENTER,
  TOP_RIGHT,
  BOTTOM_LEFT,
  BOTTOM_CENTER,
  BOTTOM_RIGHT
}

const ToastPositionCss = {
  [ToastPosition.TOP_LEFT]: 'position-top position-left',
  [ToastPosition.TOP_RIGHT]: 'position-top position-right',
  [ToastPosition.TOP_CENTER]: 'position-top position-center'
};

class Toast {
  constructor(public type: string, public message?: string, public timeout?: number | string) {
  }
}
@Component({
    selector: 'gt-toast',
    templateUrl: 'gt-toast.component.html',
    styleUrls: ['gt-toast.component.scss'],
    imports: [NgIf, NgClass, NgFor]
})

export class GtToastComponent implements OnInit {
  public toasts: Toast[] = [];
  public positionClasses;
  private destroyRef = inject(DestroyRef);

  @Input()
  public dismissible = false;

  @Input()
  public set position(position: ToastPosition) {
    this.positionClasses = ToastPositionCss[position || ToastPosition.TOP_RIGHT];
  }

  constructor(private alertService: AlertService) {
  }

  public ngOnInit() {
    this.alertService.getMessageStream()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((toast: Toast) => {
        if (toast.type) {
          toast.timeout = TIME_TO_LEAVE;
          this.toasts.push(toast);
        }
      });
  }

  public onClosed(toast: Toast) {
    this.toasts.pop();
  }
}
